import React, { useEffect, useState } from 'react';
import { LoadingButton } from '@mui/lab';
import * as XLSX from 'xlsx';
import axios from 'axios';
import jwtAuthAxios from 'app/services/auth/jwtAuth';
import ExcelJS from 'exceljs';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import { ASSET_IMAGES } from 'app/utils/constants/paths';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Fab, FormControl, Grid, InputLabel, MenuItem, Select, TextField, Tooltip, useMediaQuery } from '@mui/material';
import { daysSince, formatDate } from 'app/pages/partStoneStatus/partStoneStatus';
import { isMobileDevice } from 'app/utils/modifyArrayOfObjectsKeys';


const ExcelGenerate = ({ data = [], text = null, fileName = null }) => {
  const isMobile= isMobileDevice()
  // Extract the keys from the first object in the body array to create headings
  const generateExcel = async () => {
    const headings = ['STATUS', 'STONE', 'Lab', 'Report No', 'Shape', 'Cts', 'Color', 'Clarity', 'Cut', 'Polish', 'Symm', 'Rap', 'Disc %', 'Net Rate', 'Net Value', 'Table %', 'Depth %', 'Mesurement', 'Ratio', 'Image', 'Video'];

    let WrData = data?.map((ddata, i) => [ddata['STATUS'] || '', ddata['STONE'] || '', ddata['LAB'] || '', ddata['REPORTNO'] || '', ddata['SHAPE'] || '', Number(ddata['CARATS'] || 0), ddata['COLOR'] || '', ddata['CLARITY'] || '', ddata['CUT'] || '', ddata['POLISH'] || '', ddata['SYMM'] || '', Number(ddata['RAP_PRICE'] || ''), Number(ddata['ASK_DISC'] || 0), { formula: `=L${i + 7}-(L${i + 7}*M${i + 7}/100)` }, { formula: `=N${i + 7}*F${i + 7}` }, ddata['FL_TABLE_PER'] || 0, ddata['FL_DEPTH_PER'] || 0, ddata['FL_MEASUREMENTS'] || '', ddata['FL_RATIO'] || 0, { formula: `=HYPERLINK(CONCATENATE("https://dna-hthmd8bzgcfjetdb.z01.azurefd.net/vision/imaged/",B${i + 7},"/still.jpg"),"Image")`, font: { color: { argb: 'FF0000FF' }, underline: true } }, { formula: `=HYPERLINK(CONCATENATE("https://dna-hthmd8bzgcfjetdb.z01.azurefd.net/vision/dna.html?d=",B${i + 7},"&ic=1"),"Video")`, font: { color: { argb: 'FF0000FF' }, underline: true } }])


    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Sheet1');
    // let data = []; // Your data here...

    // Your Excel data...
    const ExcelJSData = [
      [],
      [],
      [],
      [],
      ['Total', { formula: ` ${WrData.length}` }, null, null, null,
        { formula: ` =SUM(F7:F${WrData.length + 6})` },
        null, null, null, null, null,
        { formula: ` =ROUND(SUM(L7:L${WrData.length + 6})/${WrData.length},2)` },//rap 
        // ask start
        { formula: ` =ROUND(SUM(M7:M${WrData.length + 6})/${WrData.length},2)` },//ask_disc
        { formula: `=SUM(N7:N${WrData.length + 6})` },//ask_Rate
        { formula: ` =ROUND(SUM(O7:O${WrData.length + 6}),2)` }, //ask_net_val
        // ask start
      ]
    ];

    worksheet.autoFilter = 'A6:U6';
    worksheet.addRows(ExcelJSData);

    const noteCell = worksheet.getCell('G1'); // Adjust cell address as needed
    // console.log(noteCell);
    noteCell.value = 'Note : Use filter to select stones and Check your selection Average Discount and Total amount.';
    noteCell.font = { size: 9, bold: true, color: { argb: '000000' } };
    noteCell.alignment = { wrapText: true };

    headings.forEach((heading, index) => {
      const colIndex = index + 1;
      worksheet.getCell(6, colIndex).value = heading;
      worksheet.getCell(6, colIndex).font = { size: 10, bold: true, color: { argb: 'FFFFFF' } };
      worksheet.getCell(6, colIndex).alignment = { wrapText: false };
      worksheet.getCell(6, colIndex).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: '000000' } };
      worksheet.getColumn(colIndex).width = heading.length + 7;
    });
    worksheet.addRows(WrData);
    // Fetch the base64 image data as a buffer
    let base64Image;
    try {
      const response = await fetch(ASSET_IMAGES + '/Blossom.png');
      if (response.ok) {
        base64Image = await response.arrayBuffer();
      } else {
        throw new Error('Failed to fetch the image');
      }
    } catch (error) {
      console.error(error);
      return; // Stop execution if fetching the image fails
    }
    worksheet.mergeCells('A1:D4')
    worksheet.mergeCells('G1:J4')
    // Add the image to the workbook
    const imageId = workbook.addImage({
      buffer: base64Image,
      extension: 'png',
    });

    worksheet.addImage(imageId, {
      tl: { col: 0, row: 0 },
      ext: { width: 200, height: 77.50 },
    });
    worksheet.views = [
      { state: 'frozen', xSplit: 0, ySplit: 6, activeCell: 'A2' }
    ];

    // Generate the Excel file
    try {
      const excelBuffer = await workbook.xlsx.writeBuffer();

      // Create a blob from the buffer
      const excelBlob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

      // Create a download link and trigger the download
      const url = window.URL.createObjectURL(excelBlob);
      const link = document.createElement('a');
      link.href = url;
      link.download = 'Client_Search_Result.xlsx';
      link.click();
    } catch (error) {
      console.error(error);
    }
  };
  return (isMobile?<Tooltip  title={text || 'Client Excel'}><Fab variant="contained" size='small' color='primary' disabled={!data?.length > 0} onClick={generateExcel}><FileDownloadOutlinedIcon /> </Fab></Tooltip>:<LoadingButton variant="contained" color='primary' disabled={!data?.length > 0} startIcon={<FileDownloadOutlinedIcon />} onClick={generateExcel} >{text || 'Client Excel'} </LoadingButton>
  )
};

// ========================================================================================================================

export const ExcelGenerateAdmin = ({ data = [], text = null, fileName = null }) => {
  const [open, setOpen] = React.useState(false);
  const [FromData, setFromData] = useState({ excelType: "Client", discType: "ASK_DISC", discTypePer: "0" });
  const handleChange = (e) => {
    setFromData({ ...FromData, [e.target.name]: e.target.value })
  }
  // useEffect(() => {
  //   console.log(FromData);
  // }, [FromData])
  const AdmingenerateExcel = async () => {
    const headings = ['STATUS', 'STONE', 'Lab', 'Report No', 'Shape', 'Cts', 'Color', 'Clarity', 'Cut', 'Polish', 'Symm', 'Rap', 'Ask Disc %', 'Ask Net Rate', 'Ask Net Value', 'Green Disc %', 'Green Net Rate', 'Green Net Value', 'Red Disc %', 'Red Net Rate', 'Red Net Value', 'Table %', 'Depth %', 'Mesurement', 'Ratio', 'Image', 'Video'];

    let WrData = data?.map((ddata, i) => [ddata['STATUS'] || '', ddata['STONE'] || '', ddata['LAB'] || '', ddata['REPORTNO'] || '', ddata['SHAPE'] || '', Number(ddata['CARATS'] || 0), ddata['COLOR'] || '', ddata['CLARITY'] || '', ddata['CUT'] || '', ddata['POLISH'] || '', ddata['SYMM'] || '', Number(ddata['RAP_PRICE'] || ''), Number(ddata['ASK_DISC'] || 0), { formula: `=L${i + 7}-(L${i + 7}*M${i + 7}/100)` }, { formula: `=N${i + 7}*F${i + 7}` }, Number(ddata['GREEN_DISC'] || 0), { formula: `=L${i + 7}-(L${i + 7}*P${i + 7}/100)` }, { formula: `=Q${i + 7}*F${i + 7}` }, Number(ddata['RED_DISC'] || 0), { formula: `=L${i + 7}-(L${i + 7}*S${i + 7}/100)` }, { formula: `=T${i + 7}*F${i + 7}` }, ddata['FL_TABLE_PER'] || 0, ddata['FL_DEPTH_PER'] || 0, ddata['FL_MEASUREMENTS'] || '', ddata['FL_RATIO'] || 0, { formula: `=HYPERLINK(CONCATENATE("https://dna-hthmd8bzgcfjetdb.z01.azurefd.net/vision/imaged/",B${i + 7},"/still.jpg"),"Image")`, font: { color: { argb: 'FF0000FF' }, underline: true } }, { formula: `=HYPERLINK(CONCATENATE("https://dna-hthmd8bzgcfjetdb.z01.azurefd.net/vision/dna.html?d=",B${i + 7},"&ic=1"),"Video")`, font: { color: { argb: 'FF0000FF' }, underline: true } }])
    // Extract the keys from the first object in the body array to create headings


    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Sheet1');

    // Your Excel data...
    const ExcelJSData = [
      [null, null, null, null, null, null, null, null, null, null],
      [null, null, null, null, null, null, null, null, null, null],
      [null, null, null, null, null, null, null, null, null, null],
      [null, null, null, null, null, null, null, null, null, null],
      ['Total', { formula: ` ${WrData.length}` }, null, null, null,
        { formula: ` =SUM(F7:F${WrData.length + 6})` },
        null, null, null, null, null,
        { formula: ` =ROUND(SUM(L7:L${WrData.length + 6})/${WrData.length},2)` },//rap 
        // ask start
        { formula: ` =ROUND(SUM(M7:M${WrData.length + 6})/${WrData.length},2)` },//ask_disc
        { formula: `=SUM(N7:N${WrData.length + 6})` },//ask_Rate
        { formula: ` =ROUND(SUM(O7:O${WrData.length + 6}),2)` }, //ask_net_val
        // ask start
        // green start
        { formula: ` =ROUND(SUM(P7:P${WrData.length + 6})/${WrData.length},2)` },
        { formula: ` =SUM(Q7:Q${WrData.length + 6})` },
        { formula: ` =ROUND(SUM(R7:R${WrData.length + 6}),2)` },
        // green End
        // Red start
        { formula: `=ROUND(SUM(S7:S${WrData.length + 6})/${WrData.length},2)` },
        { formula: ` =SUM(T7:T${WrData.length + 6})` },
        { formula: ` =ROUND(SUM(U7:U${WrData.length + 6}),2)` }] // Add other rows here as needed...
      // Red End
    ];
    worksheet.autoFilter = 'A6:U6';
    worksheet.addRows(ExcelJSData);

    const noteCell = worksheet.getCell('G1'); // Adjust cell address as needed
    // console.log(noteCell);
    noteCell.value = 'Note : Use filter to select stones and Check your selection Average Discount and Total amount.';
    noteCell.font = { size: 9, bold: true, color: { argb: '000000' } };
    noteCell.alignment = { wrapText: true };

    headings.forEach((heading, index) => {
      const colIndex = index + 1;
      worksheet.getCell(6, colIndex).value = heading;
      worksheet.getCell(6, colIndex).font = { size: 10, bold: true, color: { argb: 'FFFFFF' } };
      worksheet.getCell(6, colIndex).alignment = { wrapText: false };
      worksheet.getCell(6, colIndex).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: '000000' } };
      worksheet.getColumn(colIndex).width = heading.length + 7;
    });
    worksheet.addRows(WrData);
    const Greenrange = { s: { r: 6, c: 15 }, e: { r: WrData.length + 5, c: 17 } }; // A1:C3
    // Get the cell values within the range
    for (let R = Greenrange.s.r; R <= Greenrange.e.r; ++R) {
      for (let C = Greenrange.s.c; C <= Greenrange.e.c; ++C) {
        const cellVal = XLSX.utils.encode_cell({ r: R, c: C });
        // console.log(cellVal);
        worksheet.getCell(cellVal).style = {
          fill: {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: '0dff00' } // Yellow fill color (replace with your desired color)
          }
        }
        // data.push(row);
      }
    }
    const Redrange = { s: { r: 6, c: 18 }, e: { r: WrData.length + 5, c: 20 } }; // A1:C3
    // Get the cell values within the range
    for (let R = Redrange.s.r; R <= Redrange.e.r; ++R) {
      for (let C = Redrange.s.c; C <= Redrange.e.c; ++C) {
        const cellVal = XLSX.utils.encode_cell({ r: R, c: C });
        // console.log(cellVal);
        worksheet.getCell(cellVal).style = {
          fill: {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'ff0000' } // Yellow fill color (replace with your desired color)
          }, font: { color: { argb: 'FFFFFF' } }
        }
        // data.push(row);
      }
    }
    // Fetch the base64 image data as a buffer
    let base64Image;
    try {
      const response = await fetch(ASSET_IMAGES + '/Blossom.png');
      if (response.ok) {
        base64Image = await response.arrayBuffer();
      } else {
        throw new Error('Failed to fetch the image');
      }
    } catch (error) {
      console.error(error);
      return; // Stop execution if fetching the image fails
    }
    worksheet.mergeCells('A1:D4')
    worksheet.mergeCells('G1:J4')
    // Add the image to the workbook
    const imageId = workbook.addImage({
      buffer: base64Image,
      extension: 'png',
    });

    worksheet.addImage(imageId, {
      tl: { col: 0, row: 0 },
      ext: { width: 200, height: 77.50 },
    });
    worksheet.views = [
      { state: 'frozen', xSplit: 0, ySplit: 6, activeCell: 'A2' }
    ];

    // Generate the Excel file
    try {
      const excelBuffer = await workbook.xlsx.writeBuffer();

      // Create a blob from the buffer
      const excelBlob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

      // Create a download link and trigger the download
      const url = window.URL.createObjectURL(excelBlob);
      const link = document.createElement('a');
      link.href = url;
      link.download = 'Admin_Search_Result.xlsx';
      link.click();
    } catch (error) {
      console.error(error);
    }
  };
  const generateExcel = async () => {
    const headings = ['STATUS', 'STONE', 'Lab', 'Report No', 'Shape', 'Cts', 'Color', 'Clarity', 'Cut', 'Polish', 'Symm', 'Rap', 'Disc %', 'Net Rate', 'Net Value', 'Table %', 'Depth %', 'Mesurement', 'Ratio', 'Image', 'Video'];

    let WrData = data?.map((ddata, i) => [ddata['STATUS'] || '', ddata['STONE'] || '', ddata['LAB'] || '', ddata['REPORTNO'] || '', ddata['SHAPE'] || '', Number(ddata['CARATS'] || 0), ddata['COLOR'] || '', ddata['CLARITY'] || '', ddata['CUT'] || '', ddata['POLISH'] || '', ddata['SYMM'] || '', Number(ddata['RAP_PRICE'] || ''), Number(`${ddata[`${FromData.discType}`]}` - FromData.discTypePer || 0), { formula: `=L${i + 7}-(L${i + 7}*M${i + 7}/100)` }, { formula: `=N${i + 7}*F${i + 7}` }, ddata['FL_TABLE_PER'] || 0, ddata['FL_DEPTH_PER'] || 0, ddata['FL_MEASUREMENTS'] || '', ddata['FL_RATIO'] || 0, { formula: `=HYPERLINK(CONCATENATE("https://dna-hthmd8bzgcfjetdb.z01.azurefd.net/vision/imaged/",B${i + 7},"/still.jpg"),"Image")`, font: { color: { argb: 'FF0000FF' }, underline: true } }, { formula: `=HYPERLINK(CONCATENATE("https://dna-hthmd8bzgcfjetdb.z01.azurefd.net/vision/dna.html?d=",B${i + 7},"&ic=1"),"Video")`, font: { color: { argb: 'FF0000FF' }, underline: true } }])


    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Sheet1');


    // Your Excel data...
    const ExcelJSData = [
      [],
      [],
      [],
      [],
      ['Total', { formula: ` ${WrData.length}` }, null, null, null,
        { formula: ` =SUM(F7:F${WrData.length + 6})` },
        null, null, null, null, null,
        { formula: ` =ROUND(SUM(L7:L${WrData.length + 6})/${WrData.length},2)` },//rap 
        // ask start
        { formula: ` =ROUND(SUM(M7:M${WrData.length + 6})/${WrData.length},2)` },//ask_disc
        { formula: `=SUM(N7:N${WrData.length + 6})` },//ask_Rate
        { formula: ` =ROUND(SUM(O7:O${WrData.length + 6}),2)` }, //ask_net_val
        // ask start
      ]
    ];

    worksheet.autoFilter = 'A6:U6';
    worksheet.addRows(ExcelJSData);

    const noteCell = worksheet.getCell('G1'); // Adjust cell address as needed
    // console.log(noteCell);
    noteCell.value = 'Note : Use filter to select stones and Check your selection Average Discount and Total amount.';
    noteCell.font = { size: 9, bold: true, color: { argb: '000000' } };
    noteCell.alignment = { wrapText: true };

    headings.forEach((heading, index) => {
      const colIndex = index + 1;
      worksheet.getCell(6, colIndex).value = heading;
      worksheet.getCell(6, colIndex).font = { size: 10, bold: true, color: { argb: 'FFFFFF' } };
      worksheet.getCell(6, colIndex).alignment = { wrapText: false };
      worksheet.getCell(6, colIndex).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: '000000' } };
      worksheet.getColumn(colIndex).width = heading.length + 7;
    });
    worksheet.addRows(WrData);
    // Fetch the base64 image data as a buffer
    let base64Image;
    try {
      const response = await fetch(ASSET_IMAGES + '/Blossom.png');
      if (response.ok) {
        base64Image = await response.arrayBuffer();
      } else {
        throw new Error('Failed to fetch the image');
      }
    } catch (error) {
      console.error(error);
      return; // Stop execution if fetching the image fails
    }
    worksheet.mergeCells('A1:D4')
    worksheet.mergeCells('G1:J4')
    // Add the image to the workbook
    const imageId = workbook.addImage({
      buffer: base64Image,
      extension: 'png',
    });

    worksheet.addImage(imageId, {
      tl: { col: 0, row: 0 },
      ext: { width: 200, height: 77.50 },
    });
    worksheet.views = [
      { state: 'frozen', xSplit: 0, ySplit: 6, activeCell: 'A2' }
    ];

    // Generate the Excel file
    try {
      const excelBuffer = await workbook.xlsx.writeBuffer();

      // Create a blob from the buffer
      const excelBlob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

      // Create a download link and trigger the download
      const url = window.URL.createObjectURL(excelBlob);
      const link = document.createElement('a');
      link.href = url;
      link.download = 'Client_Search_Result.xlsx';
      link.click();
    } catch (error) {
      console.error(error);
    }
  };
  const isMobile = useMediaQuery('(max-width:600px)');
  return (<>
    <Dialog open={open} fullWidth maxWidth={'sm'} onClose={() => setOpen(false)}>
      <DialogTitle>Select Detail For Excel</DialogTitle>
      <DialogContent>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <FormControl fullWidth>
              <InputLabel variant="standard" id="Excel-type">Type</InputLabel>
              <Select
                labelId="Excel-type"
                id="select"
                // value={selectedValue}
                margin="dense"
                fullWidth
                name='excelType'
                value={FromData.excelType}
                onChange={handleChange}
                variant="standard"
              >
                <MenuItem value="Admin">Admin</MenuItem>
                <MenuItem value="Client">Client</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={6}>
            {FromData.excelType == 'Client' && <FormControl fullWidth>
              <InputLabel variant="standard" id="Select-disc">Select Disc</InputLabel>
              <Select
                labelId="Select-disc"
                id="Select-disc-se"
                // value={selectedValue}
                name='discType'
                margin="dense"
                fullWidth
                value={FromData.discType}
                onChange={handleChange}
                variant="standard"
              >
                <MenuItem value="ASK_DISC">Ask Disc</MenuItem>
                <MenuItem value="GREEN_DISC">Greed Disc</MenuItem>
                <MenuItem value="RED_DISC">Red Disc</MenuItem>
              </Select>
            </FormControl>}
          </Grid>
          <Grid item xs={6}>
            {FromData.excelType == 'Client' && <TextField
              id="addDisc"
              label="Disc %"
              type="addDisc"
              value={FromData.discTypePer}
              name='discTypePer'
              onChange={handleChange}
              defaultValue={0}
              fullWidth
              variant="standard"
            />}
          </Grid>
        </Grid>

      </DialogContent>
      <DialogActions>
        <Button variant="contained" disabled={!data?.length > 0} color='primary' onClick={() => setOpen(false)}>Cancel</Button>
        <Button variant="contained" disabled={!data?.length > 0} color='primary' startIcon={<FileDownloadOutlinedIcon />} onClick={() => { FromData.excelType == 'Client' ? generateExcel() : AdmingenerateExcel() }}>Download</Button>
      </DialogActions>
    </Dialog>
    {isMobile? <Tooltip title={text || 'Client Excel'} ><Fab variant="circular" size='small' disabled={!data?.length > 0} color='primary' onClick={() => setOpen(true)} ><FileDownloadOutlinedIcon /></Fab></Tooltip>: <LoadingButton variant="contained" disabled={!data?.length > 0} color='primary' startIcon={<FileDownloadOutlinedIcon />} onClick={() => setOpen(true)} >{text || 'Client Excel'} </LoadingButton>}
  </>
  )
};
//=============================================
export const BasketExcelGenerate = ({ data = [], text = null, fileName = null }) => {
 
  const [open, setOpen] = React.useState(false);
  const [FromData, setFromData] = useState({ excelType: "Client", discType: "ASK_DISC", discTypePer: "0" });
  const isMobile = isMobileDevice()
  const handleChange = (e) => {
    setFromData({ ...FromData, [e.target.name]: e.target.value })
  }
  const generateExcel = async () => {

    // Extract the keys from the first object in the body array to create headings
    const headings = ['STATUS', 'STONE', 'Lab', 'Report No', 'Shape', 'Cts', 'Color', 'Clarity', 'Cut', 'Polish', 'Symm', 'Rap', 'Disc %', 'Net Rate', 'Net Value', 'Table %', 'Depth %', 'Mesurement', 'Ratio', 'Image', 'Video'];

    let WrData = data?.map((ddata, i) => [ddata['STATUS'] || '', ddata['STONE'] || '', ddata['LAB'] || '', ddata['REPORTNO'] || '', ddata['SHAPE'] || '', Number(ddata['CARATS'] || 0), ddata['COLOR'] || '', ddata['CLARITY'] || '', ddata['CUT'] || '', ddata['POLISH'] || '', ddata['SYMM'] || '', Number(ddata['RAP_PRICE'] || ''), Number(ddata['MDISC'] || 0), { formula: `=L${i + 7}-(L${i + 7}*M${i + 7}/100)` }, { formula: `=N${i + 7}*F${i + 7}` }, ddata['FL_TABLE_PER'] || 0, ddata['FL_DEPTH_PER'] || 0, ddata['FL_MEASUREMENTS'] || '', ddata['FL_RATIO'] || 0, { formula: `=HYPERLINK(CONCATENATE("https://dna-hthmd8bzgcfjetdb.z01.azurefd.net/vision/imaged/",B${i + 7},"/still.jpg"),"Image")`, font: { color: { argb: 'FF0000FF' }, underline: true } }, { formula: `=HYPERLINK(CONCATENATE("https://dna-hthmd8bzgcfjetdb.z01.azurefd.net/vision/dna.html?d=",B${i + 7},"&ic=1"),"Video")`, font: { color: { argb: 'FF0000FF' }, underline: true } }])


    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Sheet1');
    // let data = []; // Your data here...

    // Your Excel data...
    const ExcelJSData = [
      [],
      [],
      [],
      [],
      ['Total', { formula: ` ${WrData.length}` }, null, null, null,
        { formula: ` =SUM(F7:F${WrData.length + 6})` },
        null, null, null, null, null,
        { formula: ` =ROUND(SUM(L7:L${WrData.length + 6})/${WrData.length},2)` },//rap 
        // ask start
        { formula: ` =ROUND(SUM(M7:M${WrData.length + 6})/${WrData.length},2)` },//ask_disc
        { formula: `=SUM(N7:N${WrData.length + 6})` },//ask_Rate
        { formula: ` =ROUND(SUM(O7:O${WrData.length + 6}),2)` }, //ask_net_val
        // ask start
      ]];
    worksheet.autoFilter = 'A6:U6';
    worksheet.addRows(ExcelJSData);

    const noteCell = worksheet.getCell('G1'); // Adjust cell address as needed
    // console.log(noteCell);
    noteCell.value = 'Note : Use filter to select stones and Check your selection Average Discount and Total amount.';
    noteCell.font = { size: 9, bold: true, color: { argb: '000000' } };
    noteCell.alignment = { wrapText: true };

    headings.forEach((heading, index) => {
      const colIndex = index + 1;
      worksheet.getCell(6, colIndex).value = heading;
      worksheet.getCell(6, colIndex).font = { size: 10, bold: true, color: { argb: 'FFFFFF' } };
      worksheet.getCell(6, colIndex).alignment = { wrapText: false };
      worksheet.getCell(6, colIndex).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: '000000' } };
      worksheet.getColumn(colIndex).width = heading.length + 7;
    });
    worksheet.addRows(WrData);
    // Fetch the base64 image data as a buffer
    let base64Image;
    try {
      const response = await fetch(ASSET_IMAGES + '/Blossom.png');
      if (response.ok) {
        base64Image = await response.arrayBuffer();
      } else {
        throw new Error('Failed to fetch the image');
      }
    } catch (error) {
      console.error(error);
      return; // Stop execution if fetching the image fails
    }
    worksheet.mergeCells('A1:D4')
    worksheet.mergeCells('G1:J4')
    // Add the image to the workbook
    const imageId = workbook.addImage({
      buffer: base64Image,
      extension: 'png',
    });

    worksheet.addImage(imageId, {
      tl: { col: 0, row: 0 },
      ext: { width: 200, height: 77.50 },
    });
    worksheet.views = [
      { state: 'frozen', xSplit: 0, ySplit: 6, activeCell: 'A2' }
    ];

    // Generate the Excel file
    try {
      const excelBuffer = await workbook.xlsx.writeBuffer();

      // Create a blob from the buffer
      const excelBlob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

      // Create a download link and trigger the download
      const url = window.URL.createObjectURL(excelBlob);
      const link = document.createElement('a');
      link.href = url;
      link.download = 'Client_Basket.xlsx';
      link.click();
    } catch (error) {
      console.error(error);
    }
  };
  const AdmingenerateExcel = async () => {
    const headings = ['STATUS', 'STONE', 'Lab', 'Report No', 'Shape', 'Cts', 'Color', 'Clarity', 'Cut', 'Polish', 'Symm', 'Rap', 'Offer Disc %', 'Offer Net Rate', 'Offer Net Value', 'Ask Disc %', 'Ask Net Rate', 'Ask Net Value', 'Green Disc %', 'Green Net Rate', 'Green Net Value', 'Red Disc %', 'Red Net Rate', 'Red Net Value', 'Table %', 'Depth %', 'Mesurement', 'Ratio', 'Image', 'Video'];

    let WrData = data?.map((ddata, i) => [ddata['STATUS'] || '',
    ddata['STONE'] || '',
    ddata['LAB'] || '',
    ddata['REPORTNO'] || '',
    ddata['SHAPE'] || '',
    Number(ddata['CARATS'] || 0),
    ddata['COLOR'] || '',
    ddata['CLARITY'] || '',
    ddata['CUT'] || '',
    ddata['POLISH'] || '',
    ddata['SYMM'] || '',
    Number(ddata['RAP_PRICE'] || ''),
    Number(ddata['MDISC'] || 0),
    { formula: `=L${i + 7}-(L${i + 7}*M${i + 7}/100)` },
    { formula: `=N${i + 7}*F${i + 7}` },
    Number(ddata['ASK_DISC'] || 0),
    { formula: `=L${i + 7}-(L${i + 7}*P${i + 7}/100)` },
    { formula: `=Q${i + 7}*F${i + 7}` },
    Number(ddata['GREEN_DISC'] || 0),
    { formula: `=L${i + 7}-(L${i + 7}*S${i + 7}/100)` },
    { formula: `=T${i + 7}*F${i + 7}` },
    Number(ddata['RED_DISC'] || 0),
    { formula: `=L${i + 7}-(L${i + 7}*V${i + 7}/100)` },
    { formula: `=W${i + 7}*F${i + 7}` },
    ddata['FL_TABLE_PER'] || 0,
    ddata['FL_DEPTH_PER'] || 0,
    ddata['FL_MEASUREMENTS'] || '',
    ddata['FL_RATIO'] || 0,
    { formula: `=HYPERLINK(CONCATENATE("https://dna-hthmd8bzgcfjetdb.z01.azurefd.net/vision/imaged/",B${i + 7},"/still.jpg"),"Image")`, font: { color: { argb: 'FF0000FF' }, underline: true } }, { formula: `=HYPERLINK(CONCATENATE("https://dna-hthmd8bzgcfjetdb.z01.azurefd.net/vision/dna.html?d=",B${i + 7},"&ic=1"),"Video")`, font: { color: { argb: 'FF0000FF' }, underline: true } }])

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Sheet1');
    // let data = []; // Your data here...

    // Your Excel data...
    const ExcelJSData = [
      [],
      [],
      [],
      [],
      ['Total', { formula: ` ${WrData.length}` }, null, null, null,
        { formula: ` =SUM(F7:F${WrData.length + 6})` },
        null, null, null, null, null,
        { formula: ` =ROUND(SUM(L7:L${WrData.length + 6})/${WrData.length},2)` },//rap 
        // ask start
        { formula: ` =ROUND(SUM(M7:M${WrData.length + 6})/${WrData.length},2)` },//ask_disc
        { formula: `=SUM(N7:N${WrData.length + 6})` },//ask_Rate
        { formula: ` =ROUND(SUM(O7:O${WrData.length + 6}),2)` }, //ask_net_val
        // ask start
        // green start
        { formula: ` =ROUND(SUM(P7:P${WrData.length + 6})/${WrData.length},2)` },
        { formula: ` =SUM(Q7:Q${WrData.length + 6})` },
        { formula: ` =ROUND(SUM(R7:R${WrData.length + 6}),2)` },
        // green End
        // Red start
        { formula: `=ROUND(SUM(S7:S${WrData.length + 6})/${WrData.length},2)` },
        { formula: ` =SUM(T7:T${WrData.length + 6})` },
        { formula: ` =ROUND(SUM(U7:U${WrData.length + 6}),2)` },
        { formula: `=ROUND(SUM(V7:V${WrData.length + 6})/${WrData.length},2)` },
        { formula: ` =SUM(W7:W${WrData.length + 6})` },
        { formula: ` =ROUND(SUM(X7:X${WrData.length + 6}),2)` }
      ]
    ];
    worksheet.autoFilter = 'A6:U6';
    worksheet.addRows(ExcelJSData);

    const noteCell = worksheet.getCell('G1'); // Adjust cell address as needed
    // console.log(noteCell);
    noteCell.value = 'Note : Use filter to select stones and Check your selection Average Discount and Total amount.';
    noteCell.font = { size: 9, bold: true, color: { argb: '000000' } };
    noteCell.alignment = { wrapText: true };

    headings.forEach((heading, index) => {
      const colIndex = index + 1;
      worksheet.getCell(6, colIndex).value = heading;
      worksheet.getCell(6, colIndex).font = { size: 10, bold: true, color: { argb: 'FFFFFF' } };
      worksheet.getCell(6, colIndex).alignment = { wrapText: false };
      worksheet.getCell(6, colIndex).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: '000000' } };
      worksheet.getColumn(colIndex).width = heading.length + 7;
    });
    worksheet.addRows(WrData);
    // const GreenstartCell = 'P7';
    // const GreenendCell = `R${WrData.length+6}`;
    // console.log();
    // Get the cell range
    const Offerrange = { s: { r: 6, c: 12 }, e: { r: WrData.length + 5, c: 14 } }; // A1:C3
    // Get the cell values within the range
    for (let R = Offerrange.s.r; R <= Offerrange.e.r; ++R) {
      for (let C = Offerrange.s.c; C <= Offerrange.e.c; ++C) {
        const cellVal = XLSX.utils.encode_cell({ r: R, c: C });
        // console.log(cellVal);
        worksheet.getCell(cellVal).style = {
          fill: {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: '97f4f5' }
          }
        }
        // data.push(row);
      }
    }
    const Greenrange = { s: { r: 6, c: 18 }, e: { r: WrData.length + 5, c: 20 } }; // A1:C3
    // Get the cell values within the range
    for (let R = Greenrange.s.r; R <= Greenrange.e.r; ++R) {
      for (let C = Greenrange.s.c; C <= Greenrange.e.c; ++C) {
        const cellVal = XLSX.utils.encode_cell({ r: R, c: C });
        // console.log(cellVal);
        worksheet.getCell(cellVal).style = {
          fill: {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: '0dff00' } // Yellow fill color (replace with your desired color)
          }
        }
        // data.push(row);
      }
    }
    const Redrange = { s: { r: 6, c: 21 }, e: { r: WrData.length + 5, c: 23 } }; // A1:C3
    // Get the cell values within the range
    for (let R = Redrange.s.r; R <= Redrange.e.r; ++R) {
      for (let C = Redrange.s.c; C <= Redrange.e.c; ++C) {
        const cellVal = XLSX.utils.encode_cell({ r: R, c: C });
        // console.log(cellVal);
        worksheet.getCell(cellVal).style = {
          fill: {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'ff0000' } // Yellow fill color (replace with your desired color)
          }, font: { color: { argb: 'FFFFFF' } }
        }
        // data.push(row);
      }
    }
    // Fetch the base64 image data as a buffer
    let base64Image;
    try {
      const response = await fetch(ASSET_IMAGES + '/Blossom.png');
      if (response.ok) {
        base64Image = await response.arrayBuffer();
      } else {
        throw new Error('Failed to fetch the image');
      }
    } catch (error) {
      console.error(error);
      return; // Stop execution if fetching the image fails
    }
    worksheet.mergeCells('A1:D4')
    worksheet.mergeCells('G1:J4')
    // Add the image to the workbook
    const imageId = workbook.addImage({
      buffer: base64Image,
      extension: 'png',
    });

    worksheet.addImage(imageId, {
      tl: { col: 0, row: 0 },
      ext: { width: 200, height: 77.50 },
    });
    worksheet.views = [
      { state: 'frozen', xSplit: 0, ySplit: 6, activeCell: 'A2' }
    ];

    // Generate the Excel file
    try {
      const excelBuffer = await workbook.xlsx.writeBuffer();

      // Create a blob from the buffer
      const excelBlob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

      // Create a download link and trigger the download
      const url = window.URL.createObjectURL(excelBlob);
      const link = document.createElement('a');
      link.href = url;
      link.download = 'Admin_Basket.xlsx';
      link.click();
    } catch (error) {
      console.error(error);
    }
  };
  return (<><Dialog open={open} fullWidth maxWidth={'sm'} onClose={() => setOpen(false)}>
    <DialogTitle>Select Detail For Excel</DialogTitle>
    <DialogContent>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <FormControl fullWidth>
            <InputLabel variant="standard" id="Excel-type">Type</InputLabel>
            <Select
              labelId="Excel-type"
              id="select"
              // value={selectedValue}
              margin="dense"
              fullWidth
              name='excelType'
              value={FromData.excelType}
              onChange={handleChange}
              variant="standard"
            >
              <MenuItem value="Admin">Admin</MenuItem>
              <MenuItem value="Client">Client</MenuItem>
            </Select>
          </FormControl>
        </Grid>

      </Grid>

    </DialogContent>
    <DialogActions>
      <Button variant="contained" disabled={!data?.length > 0} color='primary' onClick={() => setOpen(false)}>Cancel</Button>
      <Button variant="contained" disabled={!data?.length > 0} color='primary' startIcon={<FileDownloadOutlinedIcon />} onClick={() => { FromData.excelType == 'Client' ? generateExcel() : AdmingenerateExcel() }}>Download</Button>
    </DialogActions>
  </Dialog>
  {isMobile? <Tooltip title={text || 'Client Excel'} ><Fab variant="circular" size='small' disabled={!data?.length > 0} color='primary' onClick={() => setOpen(true)} ><FileDownloadOutlinedIcon /></Fab></Tooltip>: <LoadingButton variant="contained" disabled={!data?.length > 0} color='primary' startIcon={<FileDownloadOutlinedIcon />} onClick={() => setOpen(true)} >{text || 'Client Excel'} </LoadingButton>}
  {/* <LoadingButton variant="contained" disabled={!data?.length > 0} color='primary' startIcon={<FileDownloadOutlinedIcon />} onClick={() => setOpen(true)} >{text || 'Client Excel'} </LoadingButton> */}
  </>
  )
};
//=============================================



export const BasketExcelGenerateAdmin = ({ data = [], text = null, fileName = null }) => {
  // Extract the keys from the first object in the body array to create headings
  const headings = ['STATUS', 'STONE', 'Lab', 'Report No', 'Shape', 'Cts', 'Color', 'Clarity', 'Cut', 'Polish', 'Symm', 'Rap', 'Offer Disc %', 'Offer Net Rate', 'Offer Net Value', 'Ask Disc %', 'Ask Net Rate', 'Ask Net Value', 'Green Disc %', 'Green Net Rate', 'Green Net Value', 'Red Disc %', 'Red Net Rate', 'Red Net Value', 'Table %', 'Depth %', 'Mesurement', 'Ratio', 'Image', 'Video'];

  let WrData = data?.map((ddata, i) => [ddata['STATUS'] || '',
  ddata['STONE'] || '',
  ddata['LAB'] || '',
  ddata['REPORTNO'] || '',
  ddata['SHAPE'] || '',
  Number(ddata['CARATS'] || 0),
  ddata['COLOR'] || '',
  ddata['CLARITY'] || '',
  ddata['CUT'] || '',
  ddata['POLISH'] || '',
  ddata['SYMM'] || '',
  Number(ddata['RAP_PRICE'] || ''),
  Number(ddata['MDISC'] || 0),
  { formula: `=L${i + 7}-(L${i + 7}*M${i + 7}/100)` },
  { formula: `=N${i + 7}*F${i + 7}` },
  Number(ddata['ASK_DISC'] || 0),
  { formula: `=L${i + 7}-(L${i + 7}*P${i + 7}/100)` },
  { formula: `=Q${i + 7}*F${i + 7}` },
  Number(ddata['GREEN_DISC'] || 0),
  { formula: `=L${i + 7}-(L${i + 7}*S${i + 7}/100)` },
  { formula: `=T${i + 7}*F${i + 7}` },
  Number(ddata['RED_DISC'] || 0),
  { formula: `=L${i + 7}-(L${i + 7}*V${i + 7}/100)` },
  { formula: `=W${i + 7}*F${i + 7}` },
  ddata['FL_TABLE_PER'] || 0,
  ddata['FL_DEPTH_PER'] || 0,
  ddata['FL_MEASUREMENTS'] || '',
  ddata['FL_RATIO'] || 0,
  { formula: `=HYPERLINK(CONCATENATE("https://dna-hthmd8bzgcfjetdb.z01.azurefd.net/vision/imaged/",B${i + 7},"/still.jpg"),"Image")`, font: { color: { argb: 'FF0000FF' }, underline: true } }, { formula: `=HYPERLINK(CONCATENATE("https://dna-hthmd8bzgcfjetdb.z01.azurefd.net/vision/dna.html?d=",B${i + 7},"&ic=1"),"Video")`, font: { color: { argb: 'FF0000FF' }, underline: true } }])


  const AdmingenerateExcel = async () => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Sheet1');
    let data = []; // Your data here...

    // Your Excel data...
    const ExcelJSData = [
      [],
      [],
      [],
      [],
      ['Total', { formula: ` ${WrData.length}` }, null, null, null,
        { formula: ` =SUM(F7:F${WrData.length + 6})` },
        null, null, null, null, null,
        { formula: ` =ROUND(SUM(L7:L${WrData.length + 6})/${WrData.length},2)` },//rap 
        // ask start
        { formula: ` =ROUND(SUM(M7:M${WrData.length + 6})/${WrData.length},2)` },//ask_disc
        { formula: `=SUM(N7:N${WrData.length + 6})` },//ask_Rate
        { formula: ` =ROUND(SUM(O7:O${WrData.length + 6}),2)` }, //ask_net_val
        // ask start
        // green start
        { formula: ` =ROUND(SUM(P7:P${WrData.length + 6})/${WrData.length},2)` },
        { formula: ` =SUM(Q7:Q${WrData.length + 6})` },
        { formula: ` =ROUND(SUM(R7:R${WrData.length + 6}),2)` },
        // green End
        // Red start
        { formula: `=ROUND(SUM(S7:S${WrData.length + 6})/${WrData.length},2)` },
        { formula: ` =SUM(T7:T${WrData.length + 6})` },
        { formula: ` =ROUND(SUM(U7:U${WrData.length + 6}),2)` },
        { formula: `=ROUND(SUM(V7:V${WrData.length + 6})/${WrData.length},2)` },
        { formula: ` =SUM(W7:W${WrData.length + 6})` },
        { formula: ` =ROUND(SUM(X7:X${WrData.length + 6}),2)` }
      ]
    ];
    worksheet.autoFilter = 'A6:U6';
    worksheet.addRows(ExcelJSData);

    const noteCell = worksheet.getCell('G1'); // Adjust cell address as needed
    // console.log(noteCell);
    noteCell.value = 'Note : Use filter to select stones and Check your selection Average Discount and Total amount.';
    noteCell.font = { size: 9, bold: true, color: { argb: '000000' } };
    noteCell.alignment = { wrapText: true };

    headings.forEach((heading, index) => {
      const colIndex = index + 1;
      worksheet.getCell(6, colIndex).value = heading;
      worksheet.getCell(6, colIndex).font = { size: 10, bold: true, color: { argb: 'FFFFFF' } };
      worksheet.getCell(6, colIndex).alignment = { wrapText: false };
      worksheet.getCell(6, colIndex).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: '000000' } };
      worksheet.getColumn(colIndex).width = heading.length + 7;
    });
    worksheet.addRows(WrData);
    // const GreenstartCell = 'P7';
    // const GreenendCell = `R${WrData.length+6}`;
    // console.log();
    // Get the cell range
    const Offerrange = { s: { r: 6, c: 12 }, e: { r: WrData.length + 5, c: 14 } }; // A1:C3
    // Get the cell values within the range
    for (let R = Offerrange.s.r; R <= Offerrange.e.r; ++R) {
      for (let C = Offerrange.s.c; C <= Offerrange.e.c; ++C) {
        const cellVal = XLSX.utils.encode_cell({ r: R, c: C });
        // console.log(cellVal);
        worksheet.getCell(cellVal).style = {
          fill: {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: '97f4f5' }
          }
        }
        // data.push(row);
      }
    }
    const Greenrange = { s: { r: 6, c: 18 }, e: { r: WrData.length + 5, c: 20 } }; // A1:C3
    // Get the cell values within the range
    for (let R = Greenrange.s.r; R <= Greenrange.e.r; ++R) {
      for (let C = Greenrange.s.c; C <= Greenrange.e.c; ++C) {
        const cellVal = XLSX.utils.encode_cell({ r: R, c: C });
        // console.log(cellVal);
        worksheet.getCell(cellVal).style = {
          fill: {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: '0dff00' } // Yellow fill color (replace with your desired color)
          }
        }
        // data.push(row);
      }
    }
    const Redrange = { s: { r: 6, c: 21 }, e: { r: WrData.length + 5, c: 23 } }; // A1:C3
    // Get the cell values within the range
    for (let R = Redrange.s.r; R <= Redrange.e.r; ++R) {
      for (let C = Redrange.s.c; C <= Redrange.e.c; ++C) {
        const cellVal = XLSX.utils.encode_cell({ r: R, c: C });
        // console.log(cellVal);
        worksheet.getCell(cellVal).style = {
          fill: {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'ff0000' } // Yellow fill color (replace with your desired color)
          }, font: { color: { argb: 'FFFFFF' } }
        }
        // data.push(row);
      }
    }
    // Fetch the base64 image data as a buffer
    let base64Image;
    try {
      const response = await fetch(ASSET_IMAGES + '/Blossom.png');
      if (response.ok) {
        base64Image = await response.arrayBuffer();
      } else {
        throw new Error('Failed to fetch the image');
      }
    } catch (error) {
      console.error(error);
      return; // Stop execution if fetching the image fails
    }
    worksheet.mergeCells('A1:D4')
    worksheet.mergeCells('G1:J4')
    // Add the image to the workbook
    const imageId = workbook.addImage({
      buffer: base64Image,
      extension: 'png',
    });

    worksheet.addImage(imageId, {
      tl: { col: 0, row: 0 },
      ext: { width: 200, height: 77.50 },
    });
    worksheet.views = [
      { state: 'frozen', xSplit: 0, ySplit: 6, activeCell: 'A2' }
    ];

    // Generate the Excel file
    try {
      const excelBuffer = await workbook.xlsx.writeBuffer();

      // Create a blob from the buffer
      const excelBlob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

      // Create a download link and trigger the download
      const url = window.URL.createObjectURL(excelBlob);
      const link = document.createElement('a');
      link.href = url;
      link.download = 'Admin_Basket.xlsx';
      link.click();
    } catch (error) {
      console.error(error);
    }
  };
  return (<LoadingButton variant="contained" disabled={!data?.length > 0} sx={{ display: 'flex', margin: '0 0px 22px 0' }} color='primary' startIcon={<FileDownloadOutlinedIcon />} onClick={AdmingenerateExcel} >{text || 'Client Excel'} </LoadingButton>
  )
};


export const ExcelTransactionExp = ({onClickf,text="Export To Excel"}) => {
  // Extract the keys from the first object in the body array to create headings
  const headings = ['Sr No','Ivoice no.','Date','Terms','D.Date','Days','Party Name','Stone Id','Lab','ReportNo','Shape','Carats','Color','Clarity','RapPrice','Rap Value','Disc%','Rate/Ct','Amt ($)','Amt (RMB)'];
  const [loading,setLoading]  = useState(false)
 
  // ddata['STONE'] || '',
  // ddata['LAB'] || '',
  // ddata['REPORTNO'] || '',
  // ddata['SHAPE'] || '',
  // Number(ddata['CARATS'] || 0),
  // ddata['COLOR'] || '',
  // ddata['CLARITY'] || '',
  // ddata['CUT'] || '',
  // ddata['POLISH'] || '',
  // ddata['SYMM'] || '',
  // Number(ddata['RAP_PRICE'] || ''),
  // Number(ddata['MDISC'] || 0),
  // { formula: `=L${i + 7}-(L${i + 7}*M${i + 7}/100)` },
  // { formula: `=N${i + 7}*F${i + 7}` },
  // Number(ddata['ASK_DISC'] || 0),
  // { formula: `=L${i + 7}-(L${i + 7}*P${i + 7}/100)` },
  // { formula: `=Q${i + 7}*F${i + 7}` },
  // Number(ddata['GREEN_DISC'] || 0),
  // { formula: `=L${i + 7}-(L${i + 7}*S${i + 7}/100)` },
  // { formula: `=T${i + 7}*F${i + 7}` },
  // Number(ddata['RED_DISC'] || 0),
  // { formula: `=L${i + 7}-(L${i + 7}*V${i + 7}/100)` },
  // { formula: `=W${i + 7}*F${i + 7}` },
  // ddata['FL_TABLE_PER'] || 0,
  // ddata['FL_DEPTH_PER'] || 0,
  // ddata['FL_MEASUREMENTS'] || '',
  // ddata['FL_RATIO'] || 0,
  // { formula: `=HYPERLINK(CONCATENATE("https://dna-hthmd8bzgcfjetdb.z01.azurefd.net/vision/imaged/",B${i + 7},"/still.jpg"),"Image")`, font: { color: { argb: 'FF0000FF' }, underline: true } }, { formula: `=HYPERLINK(CONCATENATE("https://dna-hthmd8bzgcfjetdb.z01.azurefd.net/vision/dna.html?d=",B${i + 7},"&ic=1"),"Video")`, font: { color: { argb: 'FF0000FF' }, underline: true } }



  const AdmingenerateExcel = async () => {
    setLoading(true)
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Sheet1');
    let TRDATA = await onClickf();
    // let data = []; // Your data here...
    if(TRDATA == false){
      setLoading(false)
      return
    }
    // console.log(TRDATA);
    // return
    // let WrData =  TRDATA?.map((ddata, i) => [i+1,ddata['FL_BILL_NO'],formatDate(ddata['FL_TRANS_DATE']),ddata['TERM'],formatDate(ddata['DUEDATE']),daysSince(ddata['FL_TRANS_DATE']),ddata['PARTYNAME'],ddata['FL_STONE_ID'],ddata['FL_CERTIFICATE'],ddata['FL_CERTIFICATENO'],ddata['FL_SHAPE'],ddata['FL_WGT'],ddata['FL_COLOR'],ddata['FL_CLARITY'],ddata['FL_RAP_PRICE_US'],Number(ddata['FL_RAP_PRICE_US'])*Number(ddata['FL_WGT']),ddata['FL_SALEDISC'],{formula:`=O${i+7}-(O${i+7}*Q${i+7}/100)`},{formula:`R${i+7}*L${i+7}`},{formula:`S${i+7}*${Number(ddata['FL_CONV_RATE'])}`}])
    let WrData =  TRDATA?.map((ddata, i) => [i+1,ddata['FL_BILL_NO'],formatDate(ddata['FL_TRANS_DATE']),ddata['TERM'],formatDate(ddata['DUEDATE']),daysSince(ddata['FL_TRANS_DATE']),ddata['PARTYNAME'],ddata['FL_STONE_ID'],ddata['FL_CERTIFICATE'],ddata['FL_CERTIFICATENO'],ddata['FL_SHAPE'],ddata['FL_WGT'],ddata['FL_COLOR'],ddata['FL_CLARITY'],ddata['FL_RAP_PRICE_US'],Number(ddata['FL_RAP_PRICE_US'])*Number(ddata['FL_WGT']),Number((ddata['FL_SALEDISC'])?.toFixed(2)),Number((ddata['FL_SALERATE'])?.toFixed(2)),Number((ddata['FL_AMT1'])?.toFixed(2)),Number((ddata['FL_AMT2'])?.toFixed(2))])
    // Your Excel data...
    // const ExcelJSData = [
    //   [],
    //   [],
    //   [],
    //   [],
    //   ['Total', { formula: ` ${WrData.length}` }, null, null, null,
    //     { formula: ` =SUM(F7:F${WrData.length + 6})` },
    //     null, null, null, null, null,
    //     { formula: ` =ROUND(SUM(L7:L${WrData.length + 6})/${WrData.length},2)` },//rap 
    //     // ask start
    //     { formula: ` =ROUND(SUM(M7:M${WrData.length + 6})/${WrData.length},2)` },//ask_disc
    //     { formula: `=SUM(N7:N${WrData.length + 6})` },//ask_Rate
    //     { formula: ` =ROUND(SUM(O7:O${WrData.length + 6}),2)` }, //ask_net_val
    //     // ask start
    //     // green start
    //     { formula: ` =ROUND(SUM(P7:P${WrData.length + 6})/${WrData.length},2)` },
    //     { formula: ` =SUM(Q7:Q${WrData.length + 6})` },
    //     { formula: ` =ROUND(SUM(R7:R${WrData.length + 6}),2)` },
    //     // green End
    //     // Red start
    //     { formula: `=ROUND(SUM(S7:S${WrData.length + 6})/${WrData.length},2)` },
    //     { formula: ` =SUM(T7:T${WrData.length + 6})` },
    //     { formula: ` =ROUND(SUM(U7:U${WrData.length + 6}),2)` },
    //     { formula: `=ROUND(SUM(V7:V${WrData.length + 6})/${WrData.length},2)` },
    //     { formula: ` =SUM(W7:W${WrData.length + 6})` },
    //     { formula: ` =ROUND(SUM(X7:X${WrData.length + 6}),2)` }
    //   ]
    // ];
    worksheet.addRows([[],[],[],[],['','','','','','','','','','','',{ formula: `=SUM(L7:INDEX(L:L, MATCH(9.99999999999999E+307, L:L)))` },'',{ formula: `=AVERAGE(O7:INDEX(O:O, MATCH(9.99999999999999E+307, O:O)))` },{ formula: `=AVERAGE(P7:INDEX(P:P, MATCH(9.99999999999999E+307, P:P)))` },{ formula: `=AVERAGE(Q7:INDEX(Q:Q, MATCH(9.99999999999999E+307, Q:Q)))` },{ formula: `=AVERAGE(R7:INDEX(R:R, MATCH(9.99999999999999E+307, R:R)))` },{ formula: `=SUM(S7:INDEX(S:S, MATCH(9.99999999999999E+307, S:S)))` },{ formula: `=AVERAGE(T7:INDEX(T:T, MATCH(9.99999999999999E+307, T:T)))` }]]);
    worksheet.autoFilter = 'A6:T6';
    // worksheet.addRows(ExcelJSData);
    const noteCell = worksheet.getCell('G1'); // Adjust cell address as needed
    // console.log(noteCell);
    noteCell.value = 'Note : Use filter to select stones and Check your selection Average Discount and Total amount.';
    noteCell.font = { size: 9, bold: true, color: { argb: '000000' } };
    noteCell.alignment = { wrapText: true };

    headings.forEach((heading, index) => {
      const colIndex = index + 1;
      worksheet.getCell(6, colIndex).value = heading;
      worksheet.getCell(6, colIndex).font = { size: 10, bold: true, color: { argb: 'FFFFFF' } };
      worksheet.getCell(6, colIndex).alignment = { wrapText: false };
      worksheet.getCell(6, colIndex).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: '000000' } };
      colIndex !== 1 &&( worksheet.getColumn(colIndex).width = heading.length + 7);
    });
    worksheet.addRows(WrData);
    // const GreenstartCell = 'P7';
    // const GreenendCell = `R${WrData.length+6}`;
    // console.log();
    // Get the cell range
    // const Offerrange = { s: { r: 6, c: 12 }, e: { r: WrData.length + 5, c: 14 } }; // A1:C3
    // Get the cell values within the range
    // for (let R = Offerrange.s.r; R <= Offerrange.e.r; ++R) {
    //   for (let C = Offerrange.s.c; C <= Offerrange.e.c; ++C) {
    //     const cellVal = XLSX.utils.encode_cell({ r: R, c: C });
    //     console.log(cellVal);
    //     worksheet.getCell(cellVal).style = {
    //       fill: {
    //         type: 'pattern',
    //         pattern: 'solid',
    //         fgColor: { argb: '97f4f5' }
    //       }
    //     }
    //     // data.push(row);
    //   }
    // }
    // const Greenrange = { s: { r: 6, c: 18 }, e: { r: WrData.length + 5, c: 20 } }; // A1:C3
    // Get the cell values within the range
    // for (let R = Greenrange.s.r; R <= Greenrange.e.r; ++R) {
    //   for (let C = Greenrange.s.c; C <= Greenrange.e.c; ++C) {
    //     const cellVal = XLSX.utils.encode_cell({ r: R, c: C });
    //     console.log(cellVal);
    //     worksheet.getCell(cellVal).style = {
    //       fill: {
    //         type: 'pattern',
    //         pattern: 'solid',
    //         fgColor: { argb: '0dff00' } // Yellow fill color (replace with your desired color)
    //       }
    //     }
    //     // data.push(row);
    //   }
    // }
    // const Redrange = { s: { r: 6, c: 21 }, e: { r: WrData.length + 5, c: 23 } }; // A1:C3
    // Get the cell values within the range
    // for (let R = Redrange.s.r; R <= Redrange.e.r; ++R) {
    //   for (let C = Redrange.s.c; C <= Redrange.e.c; ++C) {
    //     const cellVal = XLSX.utils.encode_cell({ r: R, c: C });
    //     console.log(cellVal);
    //     worksheet.getCell(cellVal).style = {
    //       fill: {
    //         type: 'pattern',
    //         pattern: 'solid',
    //         fgColor: { argb: 'ff0000' } // Yellow fill color (replace with your desired color)
    //       }, font: { color: { argb: 'FFFFFF' } }
    //     }
    //     // data.push(row);
    //   }
    // }
    // Fetch the base64 image data as a buffer
    let base64Image;
    
    try {
      const response = await fetch(ASSET_IMAGES + '/Blossom.png');
      if (response.ok) {
        base64Image = await response.arrayBuffer();
      } else {
        throw new Error('Failed to fetch the image');
      }
    } catch (error) {
      console.error(error);
      return; // Stop execution if fetching the image fails
    }
    worksheet.mergeCells('A1:D4')
    worksheet.mergeCells('G1:J4')
    // Add the image to the workbook
    const imageId = workbook.addImage({
      buffer: base64Image,
      extension: 'png',
    });

    worksheet.addImage(imageId, {
      tl: { col: 0, row: 0 },
      ext: { width: 200, height: 77.50 },
    });
    worksheet.views = [
      { state: 'frozen', xSplit: 0, ySplit: 6, activeCell: 'A2' }
    ];

    // Generate the Excel file
    try {
      const excelBuffer = await workbook.xlsx.writeBuffer();

      // Create a blob from the buffer
      const excelBlob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

      // Create a download link and trigger the download
      const url = window.URL.createObjectURL(excelBlob);
      const link = document.createElement('a');
      link.href = url;
      link.download = 'history_report.xlsx';
      link.click();
      setLoading(false)
    } catch (error) {
      console.error(error);
    }}
  return (<LoadingButton loading={loading} variant="contained" sx={{ display: 'flex', margin: '0 0px 22px 0' }} color='primary' onClick={AdmingenerateExcel} >{text} </LoadingButton>
  )
}
export default ExcelGenerate;
